export enum CheckedState {
    Nok,
    Ok,
    Pending,
}
